import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { switchMap } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { PromptService } from 'src/app/services/prompt.service';
import { LoadingService } from 'src/app/services/loading.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  inputs = {
    email: {
      isFocused: false,
      inputValue: '',
    },
    password: {
      isFocused: false,
      inputValue: '',
    },
  };
  loginError = '';
  passwordMessage = '';
  passwordError = '';

  redirect = '/';

  constructor(
    private userService: UserService,
    private router: Router,
    private zone: NgZone,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private promptService: PromptService,
    private loadingService: LoadingService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('signin_view');
    if (window.location.href.includes('redirect=')) {
      const href = window.location.href;
      const slug = decodeURIComponent(href.substring(href.indexOf('redirect=') + 9))
      const modal = slug === 'dashboard' || slug === 'settings' || slug === 'notifciations' || slug.startsWith('my/') || slug.startsWith('/') ? false : true;
      this.redirect += (modal ? 'm/' : '') + slug
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  forgotPassword() {
    this.passwordError = '';
    this.passwordMessage = '';
    this.afAuth.auth.sendPasswordResetEmail(this.inputs.email.inputValue).then(
      (res) => {
        this.passwordMessage = 'Password reset email sent!';
      },
      (err) => {
        this.passwordError = err.message;
      }
    );
  }

  login() {
    this.loginError = '';
    this.loadingService.startLoading();
    this.userService.loginWithEmailAndPassword(this.inputs.email.inputValue, this.inputs.password.inputValue).subscribe(
      (credential) => {
        this.zone.run(async () => {
          if (credential) {
            this.completeLogin(credential);
          }
        });
      },
      (err) => {
        console.error(err);
        this.loadingService.stopLoading();
        this.loginError = err;
      }
    );
  }

  completeLogin(credential) {
    this.subscriptions.add(
      this.afs
        .doc(`users/${credential.user.uid}`)
        .valueChanges()
        .subscribe((user: any) => {
          if (user && user.disabled) {
            this.promptService.setPrompt({
              hidden: false,
              heading: 'Your account is disabled.',
              body: 'Would you like to enable it again?',
              confirmText: 'Enable account',
              rejectText: 'Nevermind',
            });
            this.promptService.userResponse.subscribe((res) => {
              if (res === 'confirm') {
                user.disabled = false;
                this.userService.saveUser(credential.user.uid, user).then(() => {
                  this.promptService.clearPrompt();
                  this.router.navigateByUrl(this.redirect);
                });
              } else if (res === 'reject') {
                this.promptService.clearPrompt();
                this.router.navigateByUrl(this.redirect);
              }
            });
          } else if (user) {
            this.analyticsService.event('signin_success');
            this.loadingService.stopLoading();
            this.router.navigateByUrl(this.redirect);
          } else {
            this.loadingService.stopLoading();
            this.loginError =
              'There was an error retreiving your account.  Please try again or contact an administrator.';
          }
        })
    );
  }
}
